/**
 * Où vivent les entraînements d'un enfant, écrit une fois.
 *
 * Hedi, le 27 septembre 2026 : *« je veux que les cahiers deviennent au niveau
 * de vue d'ensemble et soit le tab juste après. Appelle ça entraînements »*.
 * Les écrans de ce dossier ne sont plus sous `/v2/enfant/:id` mais sous
 * `/parents/enfant/:id/entrainements`, dans la fiche de l'enfant, dont la barre
 * du haut choisit déjà l'enfant.
 *
 * Six écrans construisaient l'adresse à la main ; ils la demandent ici. Une
 * chaîne n'est pas un import : `v2/` continue de ne rien importer de `parent/`
 * (`partition.test.ts`), elle nomme seulement l'adresse où la coquille parent la
 * monte.
 */

export function entrainementsDe(childId: string): string {
  return `/parents/enfant/${childId}/entrainements`;
}

/**
 * La nouvelle adresse d'une ancienne adresse `/v2/enfant/:id/<reste>`.
 *
 * Seul `entrainements` change de nom — le sous-onglet s'appelle désormais
 * « Composés » ; les cahiers, les sujets, « à valider », un sommaire et un
 * chapitre gardent leur segment.
 */
export function depuisLAncienneAdresse(childId: string, reste: string): string {
  const base = entrainementsDe(childId);
  const propre = reste.replace(/^\/+|\/+$/g, "");
  if (propre === "") return base;
  if (propre === "entrainements") return `${base}/composes`;
  return `${base}/${propre}`;
}
